import { useQuery } from '@tanstack/react-query'
import { technicianAgenda } from '@kronos/domain'
import type { Instant } from '@kronos/domain'
import { repository } from '../../data'
import { Link } from '../shell/Link'
import { Panel, Section } from '../primitives'
import { AnswerRow } from './AnswerRow'
import { BookedRow } from './BookedRow'
import { MINE_KEY } from './shared'

/**
 * A technician's schedule on Today: requests to answer, inline, and the next
 * booked shift. **Nothing at all when there is nothing** — Today is not the
 * place to remind anyone that a feature exists.
 */
export function TodaySchedule(): JSX.Element | null {
  const mine = useQuery({ queryKey: MINE_KEY, queryFn: () => repository.mySchedule() })
  if (!mine.data) return null
  const { timeZone, today } = mine.data
  const { needsAnswer, comingUp } = technicianAgenda(mine.data.requests, mine.data.now as Instant)
  const next = comingUp[0]
  if (needsAnswer.length === 0 && !next) return null

  return (
    <Section
      label={needsAnswer.length > 0 ? 'Asked to come in' : 'Next shift'}
      actions={
        <Link to={{ name: 'schedule' }} className="button section-button">
          My schedule
        </Link>
      }
    >
      <Panel>
        {needsAnswer.map((r) => (
          <AnswerRow key={r.id} request={r} timeZone={timeZone} today={today} />
        ))}
        {next ? (
          <div className={needsAnswer.length > 0 ? 'today-next today-next--after' : 'today-next'}>
            {needsAnswer.length > 0 ? <span className="today-next__label">Next shift</span> : null}
            <BookedRow request={next} timeZone={timeZone} today={today} now={mine.data.now} />
          </div>
        ) : null}
      </Panel>
    </Section>
  )
}
